
export default {
  methods: {
    isValidAddress: function (inputVal) {
      return inputVal.firstName &&
      inputVal.firstName !== '' &&
      inputVal.lastName &&
      inputVal.addressLine1 &&
      inputVal.suburb &&
      inputVal.postcode
    },

    isCompleteProfile: function (inputVal) {
      return inputVal.firstName &&
      inputVal.firstName !== '' &&
      inputVal.lastName !== '' &&
      inputVal.lastName &&
      inputVal.addressLine1 !== '' &&
      inputVal.addressLine1 &&
      inputVal.suburb !== '' &&
      inputVal.suburb &&
      inputVal.postcode !== '' &&
      inputVal.postcode &&
      inputVal.agreeToDataUsage != null
    },

    needsParentalApproval: function (inputVal) {
      return inputVal &&
      inputVal.parentConsented === false &&
      inputVal.underAge === true
    }
  }
}



// WEBPACK FOOTER //
// ./src/mixins/userProfile.js